import React from 'react'

const TimeoutErrorMessage: React.FC = () => (
  <React.Fragment>A timeout error occurred retrieving data.</React.Fragment>
)

export default TimeoutErrorMessage
